import { type FC } from 'react';

import { EmptyStateMessage } from '@/src/components/molecules/EmptyStateMessage';

export const NoSearchValueDisplay: FC = () => (
  <EmptyStateMessage
    illustrationVariant='picture-art'
    isImage
    subTitle='Start typing to find an activity'
    title='Where to go from here?'
  />
);
